import React, { useState, useEffect } from 'react'
import { Button, Spinner } from 'react-bootstrap'
import { postApi } from '../../../shared/services/apiHelper'
const DataListView = ({ config }) => {
    const [list, setlist] = useState([])
    const [pageData, setpageData] = useState({
        totalRows :0,
        totalPages:1,
        previous:null,
        next:null,
        currentpage:1
    })
    const [loader, setloader] = useState(false);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        getApiData()
        return () => {
        }
    }, [config])
    const getRequestPayload = (previousPage = false, nextPage = false) => {
        const payload = {
            filter: []
        };

        if (Array.isArray(config.payload?.field) && config.payload?.field.length > 0) {
            payload['field'] = config.payload?.field;
        }

        if (Array.isArray(config.payload?.filter) && Array.isArray(config.payload?.addOnfilters)) {
            payload['filter'] = [...config.payload?.filter, ...config.payload?.addOnfilters];
        } else if (Array.isArray(config.payload?.filter)) {
            payload['filter'] = [...config.payload?.filter];
        }

        if (config.payload?.sort) {
            payload['sort'] = config.payload?.sort;
        }
        
       
        if(config.pagination){
            payload["page"] = {
                "size": config?.pageSize || 10
            }
    
            if (nextPage && pageData?.next) {
                payload["page"]['next'] = pageData?.next;
            } else if (previousPage && pageData?.previous) {
                payload["page"]['previous'] = pageData?.previous;
            }
        } else {
            if(config.customPage){
                payload["page"] = {
                    "size": config?.pageSize || 10
                }
            }
        }

        return payload;
    };
    const setPage = (pageCount) => {
        if (pageCount > -1) {
            getApiData(false, true); //next page
        } else {
            // this.getTableData(true, false); //prev page
        }
    };
    const getApiData = (previousPage = false, nextPage = false) => {
        // setloader(true);
        setError(null);

        postApi(config.url, getRequestPayload(previousPage, nextPage)).then(response => {
                let totalRows = pageData?.totalRows;
                let totalPages = pageData?.totalPages;
                let previous = pageData?.previous;
                let next = pageData?.next;
                let currentpage = pageData.currentpage 
                const page = response.data.page;
                if (typeof page !== 'undefined') {
                    if (page.total) {
                        totalRows = page.total; 
                        totalPages = Math.ceil(totalRows / page.size);
                    }
                } else {
                    totalRows = response.data?.data.length;
                    totalPages=1
                    previous=null
                    next=null
                }

                if (page?.keyset?.previous) {
                    previous = page.keyset.previous;
                }

                if (page?.keyset?.next) {
                    next = page.keyset.next;
                }
                if(nextPage) {
                    currentpage = currentpage + 1
                    setlist(prev => [...prev,...response.data?.data])
                } else {
                    currentpage = 1
                    setlist(response.data?.data)
                }

                if (config.onDataLoad) {
                    config.onDataLoad(response.data?.data);
                }

                setpageData(prev=>{ return( {
                    totalRows,
                    totalPages,
                    previous,
                    next,
                    currentpage
                })   
                })
                // setloader(false)
            })
            .catch((error) => {
                // setloader(false);
                setError(error);
                setlist([]);

                if (config.onDataLoad) {
                    config.onDataLoad([]);
                }
            });
    };

    if (list) {
        return (
            <div className='w-100' style={{overflowY:"auto"}}>
                {
                   list.length > 0 && (
                        <text className='screen-sub-head text-grey ps-0'>{config.name}</text>
                    )
                }
                <div className='ps-3 mt-3'>
                    {list.map((item, index) => (
                        <div key={index} className='w-100'>
                            {config?.renderUI(item, index)}
                        </div>
                    ))}
                </div>

                {list.length > 0 && config.pagination && <div className='px-5 d-flex justify-content-end'>
                    <div>{pageData?.currentpage} of {pageData?.totalPages}</div>
                </div>}
                <div className='d-flex justify-content-center mt-5'>
                    {
                    loader ? <Spinner className='ms-2' as="span" animation="border" role="status" aria-hidden="true" /> :
                        ((pageData.totalPages > pageData.currentpage) && config.pagination) ? 
                        <Button  className='loadbutton mb-3' onClick={()=>{setPage(1)}}>Load More</Button>
                         : null
                    }
                </div>
            </div>
        )
    } else {
        return null
    }
}
export default DataListView